module.exports = __webpack_public_path__ + "static/media/illustration-blank-canvas.29f8b864.svg";